// Fetch INSIGHT DATA
export const SET_INSIGHT_DATA = "insights/SET_INSIGHT_DATA";

//Fetch graph detail
export const FETCHING_GRAPH_DETAIL = "insights/FETCHING_GRAPH_DETAIL";
export const FETCH_GRAPH_DETAIL = "insights/FETCH_GRAPH_DETAIL";
export const FETCH_GRAPH_DETAIL_SUCCESS = "insights/FETCH_GRAPH_DETAIL_SUCCESS";
export const SET_FETCH_GRAPH_DATA = "insights/SET_FETCH_GRAPH_DATA";


//Fetch TotalTillDate
export const FETCHING_TOTAL_TILL_DATE = "insights/FETCHING_TOTAL_TILL_DATE";
export const FETCH_TOTAL_TILL_DATE = "insights/FETCH_TOTAL_TILL_DATE";
export const FETCH_TOTAL_TILL_DATE_SUCCESS =
	"insights/FETCH_TOTAL_TILL_DATE_SUCCESS";

//Fetch Summary Details
export const FETCH_SUMMARY_DETAILS = "insights/FETCH_SUMMARY_DETAILS";

// Fetch Notification details
export const FETCH_NOTIFICATION_DETAIL = "insights/FETCH_NOTIFICATION_DETAIL";

export const SET_REPORT_PARAMS = "insights/SET_REPORT_PARAMS";

export const RESET_OTHER_NOTIFICATIONS_UPDATE =
	"insights/RESET_OTHER_NOTIFICATIONS_UPDATE";

export const CLEAR_REPORT_PARAMS = "insight/CLEAR_REPORT_PARAMS";

export const GET_GRAPH_FILTER = "insights/GET_GRAPH_FILTER";

export type Action =
	| { type: SET_INSIGHT_DATA, data: Object }
	| { type: FETCHING_GRAPH_DETAIL }
	| { type: FETCH_GRAPH_DETAIL, data: Array<Object> }
	| { type: FETCH_GRAPH_DETAIL_SUCCESS, data: Array<Object> }
	| { type: FETCHING_TOTAL_TILL_DATE }
	| { type: FETCH_TOTAL_TILL_DATE, data: Array<Object> }
	| { type: FETCH_TOTAL_TILL_DATE_SUCCESS, data: Array<Object> }
	| { type: SET_FILTERS, data: Array }
	| { type: SET_GLOBAL_FILTERS, data: Array}
	| { type: FETCH_NOTIFICATION_DETAIL, data: Array<Object> }
	| { type: SET_REPORT_PARAMS, data: Object }
	| { type: RESET_OTHER_NOTIFICATIONS_UPDATE }
	| { type: CLEAR_REPORT_PARAMS }
	| { type: GET_GRAPH_FILTER, data: Object };



// WEBPACK FOOTER //
// ./src/features/insights/action-types.js